import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import Layout from 'components/Layout'
import SentinelWorkspace from 'components/SentinelV2/SentinelWorkspace'

export default function SentinelPage() {
  const { t } = useTranslation()

  return (
    <Layout
      loggedIn
      title={t('Sentinel.PageTitle')}
      mobileTopBar={{ centerTitle: t('Sentinel.PageTitle') }}
    >
      <Helmet />
      <SentinelWorkspace />
    </Layout>
  )
}
